import {SubmissionError} from 'redux-form';
import {translate} from "../../../translations/i18n";

const createValidationError = (field) => {
    return new SubmissionError({
        ...field,
        _error: "Cannot send an article"
    });
}

const validateArticleForm = (values) => {

    validateTitle(values);
    validateBody(values);
    validateCategories(values);
    validateTags(values);

};

const validateTitle = (values) => {
    const {title} = values;
    if (!title) {
        throw createValidationError({title: translate('write.form_title.errors.cannot_be_empty')});
    } else if (title.length < 2) {
        throw createValidationError({title: translate('write.form_title.errors.must_be_longer')});
    } else if (title.length > 120) {
        throw createValidationError({title: translate('write.form_title.errors.must_be_shorter')});
    }
}

const validateBody = (values) => {
    const {body} = values;
    if (!body || body === '<p></p>\n') {
        throw createValidationError({body: translate('write.form_body.errors.cannot_be_empty')});
    }
}

const validateCategories = (values) => {
    const {categories} = values;
    console.log("categories", categories);

    if (!categories || categories.length === 0) {
        throw createValidationError({categories: translate('write.blog_categories.errors.select_at_least_one_category')})
    }
}

const validateTags = (values) => {
    const {tags} = values;
    console.log("tags", tags);

    if (!tags || tags.length === 0) {
        throw createValidationError({tags: translate('write.blockchain_tags.errors.select_at_least_one_tag')})
    }
}

export default validateArticleForm;
